import React from 'react';

import { jobsTypes } from './actions'


const initialState = {
    isFetching: false,
    data: []
}


export function jobs(state = initialState, action) {

    switch(action.type) {

        case jobsTypes.REQUEST:
            return {
                ...state,
                isFetching: true
            }

        case jobsTypes.RECEIVE:
            return {
                ...state,
                isFetching: false,
                // we only want unique values 
                data: action.data.sort((a, b) => a.description.localeCompare(b.description))
            }

        default:
            return state
    }
}